import React from 'react';
import classnames from 'classnames';
import { silkscreenSide } from 'shared/data/selectOptions';
import SelectComponent from 'shared/components/SelectComponent';

const SilkscreenSides = (props) => {
  const name = 'silkscreen_sides';

  const {
    onChangeParameter,
    label,
    required,
    options,
    tooltip,
    parameters,
    groupName,
    className,
    disabled,
  } = props;

  const onChange = (e) => onChangeParameter(name, e.target.value);

  return (
    <SelectComponent
      label={label}
      required={required}
      name={name}
      onChange={onChange}
      options={options}
      tooltip={tooltip}
      selected={parameters[name]}
      groupName={groupName}
      className={classnames('silkscreen-sides', className)}
      disabled={disabled} />
  );
};

SilkscreenSides.defaultProps = {
  label: Spree.translations.parameters.silkscreen_sides,
  options: silkscreenSide,
  name: 'silkscreen_sides',
  tooltip: Spree.helpForParameters.silkscreen_sides,
};

export default SilkscreenSides;
